import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import snackbar from './snackbar'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    snackbar
  }
})
